var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class SubMenu extends Component {
    constructor() {
        super('SubMenu', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($(window).width() >= 992) {
                // Build submenu based on sections
                this.submenu = $('.component-submenu nav');
                this.fixedItemsContainer = $('.component-submenu-fixed-items-container');
                this.submenu.empty();
                $('.module-sections h1').each((title) => {
                    this.submenu.append($.parseHTML(`<a href="#${title.parents('.container').attr('id')}" class="d-flex text-uppercase">${title.text()}</a>`));
                    this.fixedItemsContainer.append($.parseHTML(`<a href="#${title.parents('.container').attr('id')}" class="d-flex position-fixed z-3 text-uppercase">${title.text()}</a>`));
                });
                // Scroll spy
                $(window).on(['resize', 'scroll'], () => {
                    this.scrollSpy();
                });
                this.scrollSpy();
                // Click on submenu item scrolls to section
                $('.component-submenu-fixed-items-container a').on('click', (event, item) => {
                    event.preventDefault();
                    console.log('click', item.attr('href'));
                    $.scrollTo($(`#${item.attr('href').substring(1)}`).position().y - $('.component-header').height());
                });
            }
            this.success();
        });
    }
    scrollSpy() {
        $('.module-sections h1').each((title) => {
            const submenuItem = this.submenu.find(`a[href="#${title.parents('.container').attr('id')}"]`);
            const fixedSubmenuItem = this.fixedItemsContainer.find(`a[href="#${title.parents('.container').attr('id')}"]`);
            if (title.viewportPosition().y < submenuItem.viewportPosition().y) {
                fixedSubmenuItem.css('top', title.viewportPosition().y).addClass('is-floating');
            }
            else {
                fixedSubmenuItem.css('top', submenuItem.viewportPosition().y).removeClass('is-floating');
            }
            // Check if fixed item is overlapping with .module-banner. If yes, set color to white, otherwise to black
            if ($('.module-banner').length > 0) {
                const y = fixedSubmenuItem.viewportPosition().y + fixedSubmenuItem.height() / 2;
                if (y > $('.module-banner').viewportPosition().y && y < $('.module-banner').viewportPosition().y + $('.module-banner').height()) {
                    fixedSubmenuItem.addClass('text-white');
                }
                else {
                    fixedSubmenuItem.removeClass('text-white');
                }
            }
        });
    }
}
